// SPDX-License-Identifier: AGPL-3.0-or-later

import {makeAutoObservable} from 'mobx';

class AlphabetModeStore {
	displayEnabled = false;
	sendEnabled = false;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	toggleDisplay(): void {
		this.displayEnabled = !this.displayEnabled;
	}

	toggleSend(): void {
		this.sendEnabled = !this.sendEnabled;
	}
}

const AlphabetMode = new AlphabetModeStore();
export default AlphabetMode;
